import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { can, ProjectPermission, useProjectAccess } from '../hooks/useProjectAccess';

interface Props {
  permission: ProjectPermission;
  /** Name of the route param holding the project id (`id` or `projectId`). */
  param?: string;
  children: React.ReactNode;
}

/**
 * Keeps shared (read-only) members out of editor routes: they land back on the project instead.
 * UX only — the API rejects the same calls for roles without the permission.
 */
const RequireProjectPermission: React.FC<Props> = ({ permission, param = 'projectId', children }) => {
  const params = useParams();
  const projectId = params[param];
  const { access, loading } = useProjectAccess(projectId);

  if (loading) {
    return (
      <div className="auth-callback">
        <div className="auth-callback-card">
          <div className="spinner" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }
  if (!can(access, permission)) return <Navigate to={`/projects/${projectId}`} replace />;
  return <>{children}</>;
};

export default RequireProjectPermission;
